import _ from 'lodash';
import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import CartaPorteCatalogoManager from '../../../../catalogs/managers/CartaPorteCatalogoManager';

class CartaPorteMercanciaCantidadTransportaForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  async componentDidMount() {
    await CartaPorteCatalogoManager.boot();

    const CvesTransporte = CartaPorteCatalogoManager.get('c_cp_clave_transporte');

    let catalogos = {};

    catalogos.CvesTransporte = this.getCatalogo(CvesTransporte);

    this.setState({
        catalogos
      });
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        isValid: true
      });
    }
  }


  getCatalogo = (values) => {
    if (!!values) {
      const sorted = _.sortBy(values.map((item) => {
        return {
          label: item.descripcion,
          value: item.clave
        }
      }), 'label');

      return [
        {
          label: 'Selecciona',
          value: ''
        }
      ].concat(sorted);
    }
  }

  rules(data) {
    return {
      'Cantidad': ['required', 'numeric', 'min:0.000001'],
      'IDOrigen': ['required', 'string', 'size:8'],
      'IDDestino': ['required', 'string', 'size:8'],
      'CvesTransporte': ['string'],
    }
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    this.notifyFormDataChange(data);
  }

  notifyFormDataChange = (data) => {
    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      pedimentos: false,
      data: {}
    })
  }

  render() {
    const rules = this.rules();
    const { isValid, data = {}, catalogos = {} } = this.state;

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Cantidad"
              name="Cantidad"
              placeholder=""
              help=""
              rules={ rules.Cantidad }
              value={ data.Cantidad }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="ID Origen"
              name="IDOrigen"
              placeholder=""
              help=""
              minLength="8"
              maxLength="8"
              rules={ rules.IDOrigen }
              value={ data.IDOrigen }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="ID Destino"
              name="IDDestino"
              placeholder=""
              help=""
              minLength="8"
              maxLength="8"
              rules={ rules.IDDestino }
              value={ data.IDDestino }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="select"
              label="Claves Transporte"
              name="CvesTransporte"
              placeholder=""
              help=""
              minLength="16"
              maxLength="36"
              rules={ rules.CvesTransporte }
              value={ data.CvesTransporte }
              options={ catalogos.CvesTransporte }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row className="pt-3">
          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar Cantidad Transporta
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

export default CartaPorteMercanciaCantidadTransportaForm;